import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Check for deprecated domain and redirect to new domain
function checkDeprecatedDomain() {
  const currentHost = window.location.hostname;
  const currentPath = window.location.pathname;
  const isDevEnvironment = environment.apiUrl.includes('localhost');

  // Skip if already on the error page to avoid infinite redirect
  if (currentPath === '/deprecated-domain') {
    return;
  }

  let shouldShowErrorPage = false;

  if (isDevEnvironment && currentHost === 'localhostTest') {
    // In dev environment, test with localhost -> show error page
    shouldShowErrorPage = true;
  } else if (!isDevEnvironment && currentHost === 'app.maporium.com') {
    // In production, show error page for app.maporium.com
    shouldShowErrorPage = true;
  }

  if (shouldShowErrorPage) {
    // Store the current full path (pathname + search + hash) that user was trying to visit
    const originalPath = window.location.pathname + window.location.search + window.location.hash;
    sessionStorage.setItem('maporium-original-path', originalPath);
    window.location.href = '/deprecated-domain';
    return;
  }
}

// Run domain check before bootstrapping
checkDeprecatedDomain();

// Monkey-patch Audio constructor to track all instances
const originalAudio = window.Audio;
const audioInstances: HTMLAudioElement[] = [];

(window as any).Audio = function (...args: any[]) {
  const audio = new originalAudio(...args);
  audioInstances.push(audio);
  return audio;
};

(window as any).stopAllSounds = function () {
  audioInstances.forEach(a => {
    a.pause();
    a.currentTime = 0;
  });
};


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
